import React from "react";
import "../../Styles/certified/finzly.css";

export default function Finzly() {
  return (
    <>
      <div className="finzly-certified-details-section">
        <div className="finzly-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="finzly-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="finzly-certified-details-left">
            <img
              src="/Certified_Ribbon/Jan2026Jan2027.png"
              alt="Outstanding Workplaces Certified"
              className="finzly-certified-badge"
            />
            <div className="finzly-certified-company-names">
              <a href="https://finzly.com" target="_blank" rel="noopener noreferrer">
                <img src="https://finzly.com/wp-content/uploads/2025/12/Finzly-logo.png" alt="Finzly Logo" className="finzly-certified-company-logo" />
              </a>
              <h1 className="finzly-certified-full-name">
                Finzly India (R&D) Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="finzly-certified-details-right">
            <img
              src="/assets/finzly/4.png"
              alt="Finzly Office"
              className="finzly-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="finzly-certified-description">
          <h2>
            Why Finzly India (R&D) Private Limited is an Outstanding Workplaces
          </h2>
          <p>
            Headquartered in Charlotte, NC, and founded in 2012 by visionary minds shaping the future of banking and payments in the US, Finzly makes bank transformation radically simple. Our core-independent platform is trusted by some of the market’s leading financial institutions to transform operations and launch new products and services at speed. <br /><br />
            At Finzly, we believe that our people are our greatest asset.
            We’ve been recognized with 20+ industry awards in the last two years - including three years in a row as one of the Best and Brightest Places to Work as well as accolades for Best Parallel Core Technology, Best Corporate Payments Solution, Best Payments-as-a-Service Provider, and Best Trading System. Quite simply, Finzly is known for being the best in everything we do, giving you the perfect opportunity to grow your career with impact.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="finzly-certified-info-cards">
          <div className="finzly-certified-info-card">
            <div className="finzly-certified-info-title">COMPANY SIZE</div>
            <div className="finzly-certified-info-value">200 Employees</div>
          </div>
          <div className="finzly-certified-info-card">
            <div className="finzly-certified-info-title">INDUSTRY</div>
            <div className="finzly-certified-info-value">IT / Software</div>
          </div>
          <div className="finzly-certified-info-card">
            <div className="finzly-certified-info-title">CONNECT</div>
            <div className="finzly-certified-info-icons">
              <span className="finzly-certified-icon-round">
                <a href="https://finzly.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="finzly-certified-icon-round">
                <a href="https://www.linkedin.com/company/finzly" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="finzly-certified-icon-round">
                <a href="https://x.com/finzly" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="finzly-certified-info-card">
            <div className="finzly-certified-info-title">LOCATION (HQ)</div>
            <div className="finzly-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="finzly-certified-recognition-section">
          <h2 className="finzly-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="finzly-certified-recognition-badge">
            <img
              src="/Certified_Ribbon/Jan2026Jan2027.png"
              alt="Outstanding Workplaces Certified"
              className="finzly-certified-recognition-image"
            />
          </div>
          <div className="finzly-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="finzly-certified-life-section">
          <h2 className="finzly-certified-life-title">
            Life at Finzly India (R&D) Private Limited
          </h2>
          <div className="finzly-certified-life-gallery">
            <div className="finzly-certified-life-col">
              <img src="/assets/finzly/2.png" alt="Office 1" className="finzly-certified-life-img" />
              <img src="/assets/finzly/3.png" alt="Team 1" className="finzly-certified-life-img" />
            </div>
            <div className="finzly-certified-life-col finzly-certified-life-center">
              <img src="/assets/finzly/5.png" alt="Main Office" className="finzly-certified-life-img finzly-certified-life-img-large" />
            </div>
            <div className="finzly-certified-life-col">
              <img src="/assets/finzly/6.png" alt="Office 2" className="finzly-certified-life-img" />
              <img src="/assets/finzly/7.png" alt="Team 2" className="finzly-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
